import React from 'react';
import { observer } from 'mobx-react'
import { styled } from "../../stitches.config"
import { bodyLarge } from '../commonStyles/Fonts';
import LiveBadge from "../atoms/LiveBadge"
import Avatar from "../atoms/Avatar";
import useMediaQuery from "../../helpers/useMediaQuery";

type ExtendedProps = {
    isLiveOn?: boolean;
    startDate?: string;
    startTime?: string;
    place?: string;
    event?: string;
    author?: any;
};

interface LiveSummaryProps {
    data: ExtendedProps;
}

const LiveSummary: React.FC<LiveSummaryProps> = observer(({
    data,
}) => {
    const isDesktop = useMediaQuery('bp4');
    const {
        isLiveOn = false,
        startDate,
        startTime,
        place,
        event,
        author,
    } = data;

    return (
        <StyledLiveSummary>
            <BlackBar>
                <LiveBadge live={isLiveOn} />
                {isDesktop &&
                    <BlackBarInfo className={bodyLarge()}>
                        <p>{startDate}</p>
                        {startTime && <Dot />}
                        <p>{startTime}</p>
                        {place && <Dot />}
                        <p>{place}</p>
                        {event && <Dot />}
                        <p>{event}</p>
                    </BlackBarInfo>
                }
                <Author className={bodyLarge()}>
                    <div>
                        {isDesktop && <p>Relacjonuje</p>}
                        <p>{author.name}</p>
                    </div>
                    {isDesktop && author.img && <Avatar size="small" src={author.img} />}
                </Author>
            </BlackBar>
            <BlackBarMobile className={bodyLarge()}>
                {startDate && <div className="list-item">
                    <Dot />
                    <p>{startDate}</p>
                </div>
                }
                {startTime && <div className="list-item">
                    <Dot />
                    <p>{startTime}</p>
                </div>
                }
                {place && <div className="list-item">
                    <Dot />
                    <p>{place}</p>
                </div>
                }
                {event && <div className="list-item">
                    <Dot />
                    <p>{event}</p>
                </div>
                }
            </BlackBarMobile>
        </StyledLiveSummary>
    );
});

const StyledLiveSummary = styled('div', {
    width: "100%",
})

const BlackBar = styled('div', {
    height: "48px",
    width: "100%",
    padding: "0 16px",
    background: "$grayscale100Fixed",
    color: "$grayscale0Fixed",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@bp4": {
        padding: "0 84px",
        height: "88px",
    }
})

const Dot = styled('div', {
    width: "4px",
    height: "4px",
    backgroundColor: "$primary",
    borderRadius: "4px",
    margin: "0 8px 0 0",
    "@bp4": {
        margin: "0 10px",
    },
    "@bp5": {
        margin: "0 24px",
    }
})

const BlackBarInfo = styled('div', {
    display: "flex",
    alignItems: "center",
})

const Author = styled('div', {
    display: "flex",
    alignItems: "center",
    textAlign: "right",
    "p": {
        margin: 0,
    },
    ".avatar": {
        marginLeft: "12px",
    }
})

const BlackBarMobile = styled('div', {
    background: "$grayscale100Fixed",
    color: "$grayscale0Fixed",
    display: "flex",
    flexWrap: "wrap",
    padding: "16px 16px 4px 16px",
    "@bp4": {
        display: "none",
    },
    ".list-item": {
        display: "flex",
        alignItems: "center",
        width: "50%",
        marginBottom: "12px",
        "p": {
            margin: 0,
        }
    }
})

export default LiveSummary